import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {

			},
		},
		capabilities: {
			order: '2',
			children: {
				wrapper: {
					text: {
						align: 'right',
					},
					font: {
						size: '14px',
					},
					lineHeight: '21px',
				},
			},
		},
		search: {
			children: {
				wrapper: {
					flex: {
						grow: '1',
					},
				},
			},
		},
		searchResultItem: {
			children: {
				wrapper: {
					display: 'flex',
					justifyContent: 'space-between',
					selectors: {
						':hover': {
							color: '#0075BE',
						},
					},
				},
				leftColumn: {
					display: 'flex',
					justifyContent: 'center',
					align: {
						items: 'flex-start',
					},
					flex: {
						direction: 'column',
					},
				},
				rightColumn: {
					display: 'flex',
					justifyContent: 'center',
					align: {
						items: 'flex-end',
					},
					flex: {
						direction: 'column',
					},
					color: 'grey',
				},
			},
		},
		dropdown: {
			children: {
				singleShareClass: {
					color: '#001928',
					lineHeight: '50px',
					font: {
						size: '16px',
					},
				},
			},
		},
	},
	theme: {
		'base': {
			'application': {
				font: {
					family: 'Heebo, Arial',
					weight: 'normal',
				},
				color: '#001928',
			},
			'heading': {
				children: {
					h1: {
						font: {
							size: '36px',
							weight: '300',
						},
						lineHeight: '46px',
						margin: {
							top: '0px',
							bottom: '8px',
						},
					},
				},
			},
			'definitionList': {
				children: {
					wrapper: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
						margin: {
							bottom: '34px',
						},
					},
					separator: {
						margin: {
							_value: '0 15px',
						},
					},
					listItem: {
						font: {
							size: '16px',
						},
						lineHeight: '24px',
					},
					term: {

					},
					definition: {
						margin: {
							left: '4px',
						},
					},
				},
			},
			'dropdown': {
				position: 'relative',
				width: '100%',
				min: {
					width: '165px',
				},
				children: {
					header: {
						box: {
							sizing: 'border-box',
						},
						position: 'relative',
						display: 'inline-block',
						lineHeight: '45px',
						cursor: 'pointer',
						width: '100%',
						padding: {
							left: '5px',
						},
						font: {
							weight: 'normal',
							size: '16px',
						},
						border: {
							bottom: {
								width: '2px',
								style: 'solid',
								color: '#0075BE',
							},
						},
					},
					headerTitle: {
						float: 'left',
					},
					headerIcon: {
						float: 'right',
					},
					listItems: {
						position: 'absolute',
						background: {
							color: '#FFF',
						},
						zIndex: '1000',
						listStyle: {
							type: 'none',
						},
						display: 'inline-block',
						width: '100%',
						max: {
							height: '400px',
						},
						overflow: {
							y: 'auto',
						},
						margin: {
							_value: '0',
						},
						padding: {
							_value: '0',
						},
						border: {
							width: '1px',
							style: 'solid',
							color: '#C7C7C7',
							radius: '3px',
						},
						box: {
							shadow: '0 8px 16px 0 rgba(0, 0, 0, 0.2)',
						},
					},
					listItem: {
						color: '#001928',
						font: {
							size: '16px',
							weight: 'normal',
						},
						lineHeight: '24px',
						padding: {
							top: '13px',
							bottom: '13px',
						},
						margin: {
							_value: '0 8px',
						},
						border: {
							bottom: {
								_value: '1px solid #E7E7E7',
							},
						},
						selectors: {
							':hover': {
								color: '#0075BE',
								cursor: 'pointer',
							},
							':first-child': {
								padding: {
									top: '9.5px',
								},
							},
							':last-child': {
								border: {
									_value: 'none',
								},
								padding: {
									bottom: '11.5px',
								},
							},
						},
					},
					clickLayer: {
						zIndex: '999',
						position: 'absolute',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
					},
				},
			},
			pill: {
				display: 'block',
				text: {
					transform: 'uppercase',
				},
				overrides: [
					{
						selector: '[data-selector="base-pill-value"]',
						style: {
							display: 'inline-block',
							padding: {
								_value: '8px 16px',
							},
							font: {
								weight: 'bold',
							},
							conditionals: [
								{
									conditional: {
										conditions: [
											{
												field: 'priority',
												operator: '=',
												value: 'primary',
											},
										],
									},
									style: {
										border: {
											radius: '4px',
										},
										background: {
											color: '#005587',
										},
										color: '#ffffff',
									},
								},
							],
						},
					},
				],
			},
			search: {
				children: {
					wrapper: {
						position: 'relative',
						height: '44px',
					},
					searchBar: {
						position: 'absolute',
						zIndex: '3',
						width: '100%',
						display: 'flex',
						border: {
							_value: '1px solid #dfdfdf',
							radius: '4px',
						},
						padding: {
							_value: '10px 0',
						},
						overrides: [
							{
								selector: 'input[data-selector="base-input"]',
								style: {
									flex: {
										basis: '98%',
									},
									height: '24px',
									font: {
										size: '16px',
									},
									lineHeight: '20px',
									border: {
										_value: 'none',
									},
									outline: {
										_value: 'none',
									},
									margin: {
										_value: '0 5px',
									},
									selectors: {
										'::-webkit-input-placeholder': {
											color: '#bbbbbb',
										},
										'::-ms-clear': {
											display: 'none',
										},
									},
								},
							},
						],
					},
					searchClear: {
						min: {
							width: '24px',
						},
						cursor: 'pointer',
					},
					searchIcon: {
						flex: {
							basis: '1%',
						},
						margin: {
							left: '21px',
						},
						min: {
							width: '24px',
						},
					},
					searchPill: {
						flex: {
							basis: '1%',
						},
						height: '24px',
						margin: {
							_value: '0 10px',
						},
						padding: {
							_value: '2px 8px 0 8px',
						},
						text: {
							align: 'center',
						},
						border: {
							radius: '15px',
						},
						width: 'auto',
						whiteSpace: 'nowrap',
						conditionals: [
							{
								conditional: {
									conditions: [
										{
											field: 'priority',
											operator: '=',
											value: 'primary',
										},
									],
								},
								style: {
									background: {
										color: '#03a9f4',
									},
								},
							},
							{
								conditional: {
									conditions: [
										{
											field: 'priority',
											operator: '=',
											value: 'secondary',
										},
									],
								},
								style: {
									color: '#777777',
									background: {
										color: '#eeeeee',
									},
								},
							},
							{
								conditional: {
									conditions: [
										{
											field: 'priority',
											operator: '=',
											value: 'tertiary',
										},
									],
								},
								style: {
									color: '#cccccc',
									background: {
										color: 'none',
									},
								},
							},
						],
						overrides: [
							{
								selector: 'span[data-selector="base-pill-value"]',
								style: {
									font: {
										size: '14px',
									},
									lineHeight: '24px',
									padding: {
										_value: '0',
									},
								},
							},
						],
					},
					resultBackground: {
						position: 'fixed',
						top: '0',
						right: '0',
						bottom: '0',
						left: '0',
						background: {
							color: 'rgba(0,0,0,0.0)',
						},
						zIndex: '2',
					},
					resultCard: {
						position: 'absolute',
						top: '47px',
						listStyle: {
							type: 'none',
						},
						padding: {
							_value: '0',
						},
						margin: {
							_value: '0',
						},
						width: '100%',
						background: {
							color: 'white',
						},
						border: {
							_value: '1px solid #ccc',
						},
						zIndex: '3',
					},
					resultElement: {
						cursor: 'pointer',
						padding: {
							_value: '10px',
						},
						border: {
							bottom: {
								_value: '1px solid #ccc',
							},
						},
						selectors: {
							':nth-last-of-type': {
								_parameters: ['1'],
								border: {
									_value: 'none',
								},
							},
						},
						zIndex: '4',
					},
				},
			},
			'icon': {
				'children': {
					'wrapper': {
						'overrides': [
							{
								'selector': '[data-selector="base-icon"]',
								'style': {
									'verticalAlign': 'middle',
								},
							},
						],
					},
				},
			},
			'text': {},
			'translate': {},
			'actions': {
				'children': {
					'wrapper': {
						'display': 'flex',
					},
				},
			},
			'image': {
				'children': {
					'styledImage': {
						'verticalAlign': 'middle',
					},
				},
			},
			'asset': {},
			'link': {},
			'badge': {
				'children': {
					'wrapper': {
						'font': {
							'size': 'small',
							'family': 'body',
							'weight': 'normal',
						},
						'text': {
							'align': 'center',
						},
						'padding': {
							'top': '0.2em',
							'bottom': '0.2em',
							'left': '0.5em',
							'right': '0.5em',
						},
						'min': {
							'width': '2em',
						},
						'color': 'white',
						'background': {
							'color': '#bbb',
						},
						'border': {
							'radius': '3em',
						},
						'display': 'inline',
					},
				},
			},
			'contextMenu': {
				'children': {
					'button': {
						'border': {
							'style': 'none',
						},
						'outline': {
							'style': 'none',
						},
						'font': {
							'size': '13px',
						},
						'lineHeight': '34px',
					},
					'icon': {
						'verticalAlign': 'middle',
					},
					'dropdown': {
						'margin': {
							'top': '2px',
						},
						'padding': {
							'_value': '5px',
						},
						'border': {
							'color': '#cccccc',
							'style': 'solid',
							'width': 'thin',
							'radius': '3px',
						},
						'position': 'absolute',
						'min': {
							'width': '100px',
						},
						'background': {
							'color': 'white',
						},
					},
					'dropdownItem': {
						'display': 'block',
						'font': {
							'size': '13px',
						},
						'lineHeight': '34px',
					},
					'clickLayer': {
						'position': 'absolute',
						'top': '0',
						'bottom': '0',
						'left': '0',
						'right': '0',
						'background': {
							'color': 'transparent',
						},
					},
				},
			},
			'tabs': {
				'children': {
					'header': {
						'display': 'flex',
						'border': {
							'bottom': {
								'color': '#cccccc',
								'style': 'solid',
								'width': '1px',
							},
						},
						'margin': {
							'bottom': '10px',
						},
					},
					'tabHeader': {
						'padding': {
							'right': '20px',
						},
						'cursor': 'pointer',
						'flex': {
							'_value': '1',
						},
					},
					'activeTabHeader': {
						'font': {
							'weight': 'bold',
						},
						'color': '#1EA7FD',
						'border': {
							'bottom': {
								'color': '#1EA7FD',
								'style': 'solid',
							},
						},
					},
					'tabHeaderIcon': {
						'width': '16px',
						'height': '16px',
						'margin': {
							'right': '5px',
							'left': '5px',
						},
						'verticalAlign': 'text-top',
					},
				},
			},
			'tab': {},
			'table': {
				'width': '100%',
				'children': {
					'table': {
						'width': '100%',
						'font': {
							'family': 'Arial',
						},
					},
					'head': {
						'background': {
							'color': '#0079C1',
						},
						'color': '#FFFFFF',
					},
					'headRow': {
						'height': '55px',
					},
					'headCell': {
						'padding': {
							'right': '16px',
						},
						'text': {
							'align': 'right',
						},
						'font': {
							'size': '16px',
							'weight': 'bold',
						},
						'lineHeight': '20px',
					},
					'body': {
						'font': {
							'size': '16px',
						},
						'color': '#001928',
						'lineHeight': '24px',
					},
					'row': {
						'height': '55px',
						'background': {
							'color': '#FFFFFF',
						},
						'selectors': [
							{
								':nth-child': {
									'_parameters': [
										'odd',
									],
									'background': {
										'color': '#F5F6F7',
									},
								},
							},
						],
					},
					'cell': {
						'border': {
							'bottom': {
								'color': '#C7C7C7',
								'width': '1px',
								'style': 'solid',
							},
						},
						'selectors': [
							{
								':first-child': {
									'text': {
										'align': 'left',
									},
									'padding': {
										'left': '16px',
									},
								},
							},
						],
						'text': {
							'align': 'right',
						},
						'padding': {
							'right': '16px',
						},
					},
					'disclaimersWrapper': {
						'margin': {
							'top': '20px',
						},
					},
				},
			},
			'asOfDate': {},
			grid: {
				children: {
					row: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
					},
					column: {
						display: 'flex',
						flex: {
							_value: '1',
							direction: 'column',
						},
					},
				},
			},
		},
		'overview': {
			'commentary': {},
			'disclaimer': {
				'children': {
					'wrapper': {
						'display': 'flex',
					},
				},
			},
			'disclaimers': {},
		},
		'management': {
			'fundManager': {
				'children': {
					'wrapper': {
						'width': '150px',
						'text': {
							'align': 'center',
						},
					},
					'name': {
						'text': {
							'align': 'center',
						},
					},
					'title': {
						'text': {
							'align': 'center',
						},
						'font': {
							'size': '14px',
						},
						'color': '#888888',
					},
					'actionsWrapper': {
						'overrides': [
							{
								'selector': '[data-selector="base-actions-wrapper"]',
								'style': {
									'justifyContent': 'center',
								},
							},
						],
					},
					'imageWrapper': {
						'height': '100px',
						'overflow': {
							'y': 'hidden',
						},
						'padding': {
							'bottom': '5px',
						},
						'margin': {
							'bottom': '5px',
						},
					},
					'fundManagerImage': {
						'width': '100px',
						'height': '100px',
						'border': {
							'radius': '50%',
							'color': '#ccc',
							'width': '2px',
							'style': 'solid',
						},
					},
				},
				'overrides': [
					{
						'selector': '[data-selector="base-image"]',
						'style': {
							'width': '100px',
							'height': '100px',
							'border': {
								'radius': '50%',
							},
						},
					},
				],
			},
			'fundManagersCarousel': {
				'overrides': [
					{
						'selector': '[data-selector="management-fundManager-wrapper"]',
						'style': {
							'margin': {
								'_value': '0 auto',
							},
						},
					},
				],
			},
		},
		'charting': {
			'chartBase': {
				'height': '500px',
			},
			'barChart': {
				'font': {
					'family': 'Arial',
					'size': '11px',
				},
				'color': '#001928',
				'overrides': [
					{
						'selector': 'div.recharts-wrapper > svg > g.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis > g text',
						'style': {
							'fill': '#001928',
						},
					},
					{
						'selector': 'div.recharts-wrapper > div > ul > li.recharts-legend-item > svg',
						'style': {
							'margin': {
								'right': '12px !important',
							},
							'width': '12px',
							'height': '12px',
						},
					},
				],
			},
			'lineChart': {},
			'areaChart': {},
			'scatterChart': {},
			'chartTableCombo': {
				'children': {
					'chartWrapper': {
						'margin': {
							'bottom': '20px',
						},
					},
				},
			},
		},
		'file': {
			'documentDownload': {
				'children': {
					'documentLabel': {
						'lineHeight': '34px',
						'padding': {
							'right': '8px',
						},
					},
					'icon': {
						'verticalAlign': 'middle',
					},
					'contextMenuItemIcon': {
						'float': 'right',
					},
				},
			},
			'documentDownloadList': {
				'children': {
					'wrapper': {
						'font': {
							'size': '13px',
						},
					},
					'documentLabel': {
						'lineHeight': '34px',
					},
				},
				'overrides': [
					{
						'selector': '[data-selector="base-list"]',
						'style': {
							'padding': {
								'left': '0',
							},
						},
					},
				],
			},
			'bulkDocumentDownload': {
				'children': {
					'linkButton': {
						'border': {
							'style': 'solid',
							'width': '2px;',
							'radius': '15px',
						},
						'padding': {
							'top': '5px',
							'right': '5px',
							'bottom': '5px',
							'left': '5px',
						},
					},
				},
			},
		},
		'risk': {
			'riskRating': {
				'children': {
					'ratings': {
						'border': {
							'right': {
								'_value': 'solid 1px #ADB5BD',
							},
							'collapse': 'collapse',
						},
						'display': 'flex',
						'flex': {
							'direction': 'row',
						},
						'height': '45px',
					},
					'activeRatingBox': {
						'background': {
							'color': '#0078C0',
						},
						'color': '#FFFFFF',
						'text': {
							'align': 'center',
						},
						'flex': {
							'grow': '1',
						},
						'lineHeight': '45px',
						'border': {
							'_value': 'solid 1px #0078C0',
							'collapse': 'collapse',
						},
					},
					'ratingBox': {
						'border': {
							'_value': 'solid 1px #ADB5BD',
							'right': {
								'_value': 'none',
							},
							'collapse': 'collapse',
						},
						'text': {
							'align': 'center',
						},
						'flex': {
							'grow': '1',
						},
						'lineHeight': '45px',
					},
					'topLabels': {
						'display': 'flex',
						'flex': {
							'direction': 'row',
						},
					},
					'bottomLabels': {
						'display': 'flex',
						'flex': {
							'direction': 'row',
						},
					},
					'leftLabel': {
						'flex': {
							'grow': '1',
						},
						'text': {
							'align': 'left',
						},
					},
					'rightLabel': {
						'flex': {
							'grow': '1',
						},
						'text': {
							'align': 'right',
						},
					},
				},
			},
		},
	},
};